export default {
      id: "copy-regular-usage",
      viewBox: "0 -960 960 960",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#copy-regular-usage",
      toString: function () {
        return this.url;
      }
    }